<template>
  <div class="openWrap" id="page1">
    <div class="leftBlock">
      <h1>开源节流 就选涿溪防窜货</h1>
      <h2>日化企业防伪营销 先用涿溪防窜货</h2>
      <p>一站式全流程防伪营销，数据管理全面实现开源节流。涿溪防窜货，定义新的营销方式。</p>
      <Mybutton class="openButton" @clickFn="showForm">立即体验</Mybutton>
    </div>
    <div class="rightBlock">
      <div class="phoneBlock">
        <transition name="kouhong">
          <img v-show="itemShow" class="kouhong" src="../assets/images/kouhong.png" />
        </transition>
        <transition name="more">
          <img v-show="itemShow" class="more" src="../assets/images/more.png" />
        </transition>
        <transition name="biaoshi">
          <img v-show="itemShow" class="biaoshi" src="../assets/images/biaoshi.png" />
        </transition>
        <transition name="duigou">
          <img v-show="itemShow" class="duigou" src="../assets/images/duigou.png" />
        </transition>
        <transition name="switch">
          <img v-show="itemShow" class="switch" src="../assets/images/switch.png" />
        </transition>
        <transition name="chart">
          <img v-show="itemShow" class="chart" src="../assets/images/chart.png" />
        </transition>
        <transition name="building">
          <img v-show="itemShow" src="../assets/images/building.png" class="building" />
        </transition>
        <transition name="computer">
          <img v-show="itemShow" src="../assets/images/computer.png" class="computer" />
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Mybutton from './Mybutton'
export default {
  name: 'navigation',
  components: {
    Mybutton
  },
  props: {
    itemShow: Boolean,
    scroll:{
      type: Number,
      default: 0,
    }
  },
  data () {
    return {
      // itemShow: false,
      screenHeight: 0,
    }
  },
  methods:{
    showForm() {
      this.$emit('changeVisible', true)
    }
  },
  mounted: function(){
    // this.itemShow = true
    // this.screenHeight = document.documentElement.clientHeight
  },
  watch:{
    // scroll(val) {
    //   if(this.screenHeight == 0) {
    //     this.itemShow = true
    //   }
    //   if(!this.itemShow) {
    //     if(this.scroll <= this.screenHeight) {
    //       this.itemShow = true
    //     }
    //   }
    //   if(this.itemShow){
    //     if(this.scroll > this.screenHeight) {
    //       this.itemShow = false
    //     }
    //   }
    // }
  }

}
</script>
<style scoped lang="scss">
/**********口红动画**************/
.kouhong{
  position: absolute;
  /***动画最后一帧的状态****/
  transform: scale(1.5);
  left: -15px;
  top:32px;
}
.kouhong-enter-active {
  animation: kouhong-in .5s;
  animation-delay: .1s;
}
.kouhong-leave-active {
  animation: kouhong-in .5s reverse;
  animation-delay: .1s;
}

@keyframes kouhong-in {
  0% {
    transform: scale(0.2);
    opacity: 0.2;
    left: 13px;
    top: 32px;
  }
  30%{
    transform: scale(1);
    left: 13px;
    top: 32px;
  }
  100% {
    transform: scale(1.5);
    opacity: 1;
    left: -15px;
    top: 32px;
  }
}
/***more动画****/
.more{
  position: absolute;
  top: 32px;
  left: 96px;
  width: 219px;
  height: 76px;
}

.more-enter-active {
  animation: more-in .5s;
  animation-delay: .1s;
}
.more-leave-active {
  animation: more-in .5s reverse;
  animation-delay: .1s;
}

@keyframes more-in {
  0% {
    opacity: 0.2;
    width: 98px;
    height: 105px;
    top: 32px;
    left: 84px;
  }
  30%{
    width: 98px;
    height: 105px;
    top: 32px;
    left: 84px;
  }
  100% {
    opacity: 1;
    top: 32px;
    left: 96px;
    width: 219px;
    height: 76px;
  }
}
/***标识动画****/
.biaoshi{
  position: absolute;
  width: 132px;
  height: 90px;
  top: 107px;
  left: 96px;
}
.biaoshi-enter-active {
  animation: biaoshi-in .5s;
  animation-delay: .1s;
}
.biaoshi-leave-active {
  animation: biaoshi-in .5s reverse;
  animation-delay: .1s;
}

@keyframes biaoshi-in {
  0% {
    opacity: 0.2;
    width: 196px;
    height: 91px;
    top: 128px;
    left: 13px;
  }
  30%{
    width: 196px;
    height: 91px;
    top: 128px;
    left: 13px;
  }
  100% {
    opacity: 1;
    width: 132px;
    height: 90px;
    top: 107px;
    left: 96px;
  }
}

/**duigou动画**/
.duigou{
  position: absolute;
  width: 56px;
  height: 56px;
  top: 203px;
  left: 22px;
}
.duigou-enter-active {
  animation: duigou-in .5s;
  animation-delay: .1s;
}
.duigou-leave-active {
  animation: duigou-in .5s reverse;
  animation-delay: .1s;
}

@keyframes duigou-in {
  0% {
    top: 216px;
    left: 13px;
    opacity: 0.2;
    transform: scale(0.7)
  }
  30%{
    top: 216px;
    left: 13px;
    transform: scale(1)
  }
  100% {
    opacity: 1;
    top: 203px;
    left: 22px;
  }
}

/**switch动画**/
.switch{
  position: absolute;
  width: 151px;
  height: 76px;
  top: 191px;
  left: 95px;
}
.switch-enter-active {
  animation: switch-in .5s;
  animation-delay: .1s;
}
.switch-leave-active {
  animation: switch-in .5s reverse;
  animation-delay: .1s;
}

@keyframes switch-in {
  0% {
    opacity: 0.2;
    width: 121px;
    height: 64px;
    top: 210px;
    left: 61px;
  }
  30%{
    top: 210px;
    left: 61px;
    width: 121px;
    height: 64px;
  }
  100% {
    opacity: 1;
    width: 151px;
    height: 76px;
    top: 191px;
    left: 95px;
  }
}

/**chart动画**/
.chart{
  position: absolute;
  width: 168px;
  height: 105px;
  top: 261px;
  left: 13px;
}
.chart-enter-active {
  animation: chart-in .5s;
  animation-delay: .1s;
}
.chart-leave-active {
  animation: chart-in .5s reverse;
  animation-delay: .1s;
}

@keyframes chart-in {
  0% {
    opacity: 0.2;
    transform: scale(0.7)
  }
  30%{
    opacity: 0.3;
    transform: scale(0.7)
  }
  100% {
    opacity: 1;
    transform: scale(1)
  }
}
/**building动画**/
.building {
  width: 33px;
  height: 33px;
  right: -70px;
  top: 148px;
  position: absolute;
}
.building-enter-active {
  animation: building-in .5s;
  animation-delay: .1s;
}
.building-leave-active {
  animation: building-in .5s reverse;
  animation-delay: .1s;
}

@keyframes building-in {
  0% {
    opacity: 0.2;
    transform: scale(0.5)
  }
  30%{
    opacity: 0.3;
    right: -50px;
    transform: scale(0.7)
  }
  100% {
    opacity: 1;
    right: -70px;
    transform: scale(1)
  }
}

/***computer动画**/
.computer{
  width: 26px;
  height: 26px;
  top: 277px;
  right: -30px;
  position: absolute;
}
.computer-enter-active {
  animation: computer-in .5s;
  animation-delay: .1s;
}
.computer-leave-active {
  animation: computer-in .5s reverse;
  animation-delay: .1s;
}

@keyframes computer-in {
  0% {
    opacity: 0.2;
    transform: scale(0.5)
  }
  30%{
    opacity: 0.3;
    right: -17px;
    transform: scale(0.7)
  }
  100% {
    opacity: 1;
    right: -30px;
    transform: scale(1)
  }
}

.openWrap{
  padding: 12% 0 92px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  .leftBlock{
    .openButton{
      padding: 0 40px;
    }
    > h1 {
      font-size: 48px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: 500;
      color: #1F2329;
      line-height: 67px;
      letter-spacing: 1px;
      margin: 37px 0 18px;
      padding: 0;
    }
    > h2 {
      font-size: 18px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: normal;
      color: #1F2329;
      line-height: 25px;
      margin-bottom: 10px;
      padding: 0;
    }
    > p {
      width: 400px;
      font-size: 18px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #707885;
      line-height: 28px;
      margin: 0 0 50px 0;
      padding: 0;
    }
  }
  .rightBlock{
    width: 708px;
    height: 440px;
    background: url('../assets/images/bg_1.png') top left no-repeat;
    // border: 1px solid #f00;
    margin-right: 30px;
    .phoneBlock{
      height: 377px;
      width: 184px;
      margin-left: 457px;
      margin-top: 20px;
      position: relative;
      background: url('../assets/images/phone.png') top left no-repeat;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OpenWrap.vue